import { ExternalLink, FlaskConical } from 'lucide-react';

export function AvisoNoInvitado({ url }: { url: string }) {
  return (
    <div role="alert" className="panel-vidrio mb-5 space-y-3 text-center">
      <FlaskConical className="mx-auto text-cian-texto" size={32} aria-hidden />
      <p className="font-bold">La nueva plataforma está en beta por invitación.</p>
      <p className="text-sm text-texto-2">
        Tu cuenta, tus licencias y tu avance siguen disponibles en la plataforma actual.
      </p>
      <a href={url} className="btn-cs btn-primario w-full">
        Ir a la plataforma actual <ExternalLink size={16} aria-hidden />
      </a>
    </div>
  );
}
